var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "icon",
      staticStyle: { "pointer-events": "none", display: "block" },
      attrs: {
        viewBox: _vm.viewBox,
        preserveAspectRatio: "xMidYMid meet",
        focusable: "false",
        size: _vm.size,
      },
    },
    [
      _c(
        "g",
        _vm._b(
          {
            attrs: { id: _vm.iconName },
            domProps: { innerHTML: _vm._s(_vm.innerSvg) },
          },
          "g",
          _vm.gAttributes,
          false
        )
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }